import React from "react";
import SEO from "../../components/seo";
import useProfilePic from "../../hooks/useProfilePic";
import ProfilePage from "../../layouts/ProfilePage";

const Lorenzo = () => {
	const { lorenzo: pic } = useProfilePic();
	return (
		<>
			<SEO
				title="Our Team of Specialists"
				keywords={[`Gastroenterologist`, `Dr Lorenzo Tarquinio`]}
				description="About Dr Lorenzo Tarquinio"
			/>
			<ProfilePage
				title="Dr Lorenzo Tarquinio - Gastroenterologist & Hepatologist"
				name="Dr Lorenzo Tarquinio"
				img={pic.childImageSharp.fixed}
				quote=""
				specialty="All aspects of liver disease. General gastroenterology, including functional disorders, inflammatory bowel disease and endoscopic procedures."
				education={[
					"Undergraduate: University of Western Australia",
					"Postgraduate GI Training: Hollywood Private Hospital, Royal Perth Hospital, Fremantle Hospital, Sir Charles Gairdner Hospital",
					"Fellowship: Freeman Hospital Liver Unit, Newcastle upon Tyne ",
				]}
				description={[
					"Lorenzo has been committed to full time private practice since leaving Royal Perth Hospital in 2015 after 13 years as a staff specialist. He practices in all areas of gastroenterology and provides open access endoscopic services.",
					"Dr Tarquinio is a sub-specialist in hepatology, with his expertise being viral hepatitis, assessment of unexplained abnormal liver tests, metabolic dysfunction-associated steatotic liver disease, alcoholic liver disease, autoimmune liver disease and liver lesions.",
					"He continues to have a strong association with the Gastroenterology and Hepatology Department at Royal Perth Hospital and the Liver Unit at Sir Charles Gairdner Hospital.",
				]}
				honours={[
					"",

				]}
				background="Dr Tarquinio attained a Bachelor of Medicine and Surgery from the University of Western Australia in 1992 and commenced specialist training in 1999.  He undertook a year of sub-specialty hepatology training in Newcastle upon Tyne, United Kingdom, in 2001. Dr Tarquinio was appointed sessional consultant at Royal Perth Hospital and visiting hepatologist to Sir Charles Gairdner Hospital in 2002 on his return.  Since leaving the teaching hospitals, he has continued with medical student teaching with the University of Notre Dame, Fremantle, as an Adjunct Associate Professor."
				appointments={[
					"Private appointment - Hollywood Private Hospital, St John of God Mt Lawley, Subiaco and Midland Hospitals, Perth Day Hospital",
				]}
				memberships={[
					"Gastroenterological Society of Australia (GESA)",
					"Australian Health Practitioner Regulation Agency (AHPRA)",
					"The Royal Australasian College of Physicians (RACP)",
					"Conjoint Committee for the Recognition of Training in Gastrointestinal Endoscopy (CCRTGE)",
				]}
				personal={[
					"I have a keen interest in aviation, and I enjoy spending free time flying at the Royal Aero Club in Jandakot.",
				]}
				publications={[
					{
						publicationTitle: "Hepatic regenerative lymphoid hyperplasia-associated primary biliary cholangitis masquerading as a neoplastic lesion",
						authors: "Sim K, Fernando T, Tarquinio L, Navadgi S",
					},
				]}
			/>
		</>
	);
};

export default Lorenzo;
